import React, { useEffect } from 'react';
import '../PlatformCostObs/dashboard.scss';
import PageHeader from 'components/Header/Page';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BIApplicationIcon from '../../assets/biApplication.svg';
import { powerBIdashboardUrl } from '../../service/config';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const ResourceUtilizationAnalysis = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (window.location.pathname.includes('/databricksADB')) {
            document.head.classList.add('theme-bg-blue');
            document.body.classList.add('theme-bg-blue');
        }
    }, []);

    return (
        <div className="base-tab">
            <Box sx={{ width: '100%', marginTop: '-32px' }}>
                <PageHeader title="Databricks Resource Utilization Analysis" icon={BIApplicationIcon} />
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange}
                        sx={{
                            fontSize: "12px",
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: 40,
                                fontWeight: 500,
                                borderTopLeftRadius: 4,
                                borderTopRightRadius: 4,
                                backgroundColor: `${theme.palette.Tab.inActive.bgColor} !important`,
                                color: `${theme.palette.Tab.inActive.color} !important`,
                            },
                            '& .MuiTab-root.Mui-selected': {
                                backgroundColor: `${theme.palette.Tab.Active.bgColor} !important`,
                                color: `${theme.palette.Tab.Active.color} !important`,
                            },
                        }}
                    >
                        <Tab label="Resource Utilization" {...a11yProps(0)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <iframe
                        title="Databricks Resource Utilization Analysis"
                        width="100%"
                        height="541.25"
                        src={`${powerBIdashboardUrl.ResourceUtilizationAnalysisDashboard}`}
                        allowFullScreen
                    />
                </CustomTabPanel>
            </Box>
        </div>
    );
};

export default ResourceUtilizationAnalysis;
